import { migrateV1 } from './v1';

export const migrations = {
	1: migrateV1,
};
